import { gql } from '@apollo/client'

export default gql(`
    mutation updateLanguage($id: ID!, $name: String!, $project: String ) {
        updateLanguage(
            input: {
                name: $name
            },
            id: $id,
            project: $project
        ) {
            id
            name
            assetCount
        }
    }`
)
